import { render, staticRenderFns } from "./UniversalApp.vue?vue&type=template&id=4ae58bae&scoped=true"
import script from "./UniversalApp.vue?vue&type=script&lang=js"
export * from "./UniversalApp.vue?vue&type=script&lang=js"
import style0 from "./UniversalApp.vue?vue&type=style&index=0&id=4ae58bae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae58bae",
  null
  
)

export default component.exports